export default class formvalidateApi {

}



// WEBPACK FOOTER //
// ./src/components/formvalidate/formvalidateApi.js